<template>
  <div class="container-fluid py-4 px-4 ">
    <!-- Título -->

    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-headset display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            MESA
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
           DE AYUDA
          </p>
        </div>
      </div>
    </div>
   <div class=" border border-1 rounded-3 p-3 mb-2 ">

      <div class="col-12 d-flex justify-content-end mt-2">
        <div class="input-group buscar-estiloCuadrado" style="max-width: 350px; width: 100%;">
          <span for="" class="input-group-text mt-3 buscar-estiloCuadrado">
            <i class="bi bi-search"></i></span>
          <input class="form-control w-25 mt-3 me-2 buscar-estiloCuadrado" type="text"
            aria-label=".form-control-lg example" placeholder="" v-model="filterField" @input="filtro" />
        </div>
      </div>

      <div class="table-responsive mx-2 mt-2">
        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th>CODTRABAJADOR</th>
              <th>N° BOLETA</th>
              <th>COD. BOLETA</th>
              <th>NOMBRE BOLETA</th>
              <th>ACCIONES</th>
              <th></th>
            </tr>
          </thead>
          <tbody>

            <!-- SPINNER -->
            <tr v-if="loading">
              <td colspan="5" class="text-center align-middle" style="height: 260px;">
                <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                  <div class="spinner-border text-warning" style="width: 3.5rem; height: 3.5rem;"></div>
                  <div class="mt-3 text-secondary fw-semibold fs-5">Filtrando información...</div>
                </div>
              </td>
            </tr>

            <!-- FILAS (solo si no está cargando) -->
            <tr v-else class="text-center align-middle reducirTamaño text-nowrap" v-for="boletitas in bolePaginadas"
              :key="boletitas.id">
              <td>
                <i class="bi bi-person-fill text-primary me-1"></i>
              
              </td>

              <!-- N° Boleta -->
              <td>
                <i class="bi bi-file-earmark-text-fill text-success me-1"></i>
                
              </td>

              <!-- Código Boleta -->
              <td>
                <i class="bi bi-hash text-warning me-1"></i>
                
              </td>

              <!-- Nombre Boleta / Concepto -->
              <td class="text-start">
                <i class="bi bi-card-text text-info me-1"></i>
               
              </td>

              <!-- Acciones -->
             
              <td>
                <b-button @click="datos = boletitas" v-b-modal.modal-center class="btn btn-danger boton-estiloCuadrado">
                  <i class="bi bi-file-earmark-pdf-fill"></i>
                </b-button>
              </td>
            </tr>

          </tbody>

        </table>
      </div>
    </div>

    <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
        <i class="bi bi-chevron-double-left"></i>
      </button>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
        <i class="bi bi-chevron-left"></i>
      </button>
      <span class="pagination-info small">Página {{ currentPage }} de {{ totalPages }}</span>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-right"></i>
      </button>
      <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
        :disabled="currentPage === totalPages">
        <i class="bi bi-chevron-double-right"></i>
      </button>
    </div>
</div>
</template>

<script>

export default {
  name: 'SeguimientodeSolicitud',
  components: {
   
  },
  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>
<style  scoped>

.boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.bg-solimano {
  background: #1565C0;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.reducirTamaño {
  font-size: 0.65rem;
}
</style>

